module.exports = __webpack_public_path__ + "6cc713f72fed7698dfab4386d439be3b.pdf";